import { OnInit, Component, EventEmitter } from '@angular/core'

import {
  NavigationService, AppStateService
} from '../../'

@Component({
  selector: 'mp-main-menu',
  templateUrl: './main-menu.html',
  styleUrls: ['./main-menu.scss'],
})
export class MainMenuComponent implements OnInit {

  public menuElements: EventEmitter<any> = new EventEmitter()
  public menuTitle: String = 'Expand Menu'
  public collapsed: boolean = true

  public get path() {
    return this._appStateService.path
  }

  constructor(
    private _navigationService: NavigationService,
    private _appStateService: AppStateService
  ) {}

  public ngOnInit() {
    this._navigationService.menuStatusChange.subscribe((status: {collapsed: boolean}) => {
      this.collapsed = status.collapsed
      this.menuTitle = status.collapsed ? 'Expand Menu' : 'Collapse Menu'
    })
  }

  public toggleSidebar() {
    this._navigationService.toggleSidebar()
  }

  public navigateToSwitchSyllabus() {
    this._navigationService.navigateToSwitchSyllabus()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/main-menu/main-menu.component.ts